module.exports = "<div class=\"loader-overlay\">\n    <div class=\"loader-container\">\n        <div class=\"spinner\">\n            <div class=\"rect1\"></div>\n            <div class=\"rect2\"></div>\n            <div class=\"rect3\"></div>\n            <div class=\"rect4\"></div>\n            <div class=\"rect5\"></div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/loader/loader.component.html
// module id = ./src/app/shared/components/loader/loader.component.html
// module chunks = main